import { useQuery } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export const rendersQueryKey = (q, limit, offset) => ['platform', 'renders', q ?? '', limit ?? 50, offset ?? 0];

export function useRenders({ q, limit = 50, offset = 0 } = {}) {
  const trimmed = q?.trim();
  const params = new URLSearchParams();
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  if (trimmed) {
    params.set('q', trimmed);
  }

  return useQuery({
    queryKey: rendersQueryKey(trimmed, limit, offset),
    queryFn: () => platformApiFetch(`/api/platform/renders?${params.toString()}`),
  });
}
